import { render, staticRenderFns } from "./OrgDetailsCard.vue?vue&type=template&id=379ccd15&"
import script from "./OrgDetailsCard.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports